import { render, staticRenderFns } from "./privateNumber.vue?vue&type=template&id=b9aa1b84&scoped=true&"
import script from "./privateNumber.vue?vue&type=script&lang=js&"
export * from "./privateNumber.vue?vue&type=script&lang=js&"
import style0 from "./privateNumber.vue?vue&type=style&index=0&id=b9aa1b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aa1b84",
  null
  
)

export default component.exports